<mat-card class="admin-card enterprise-card">
  <mat-card-header class="page-head">
    <div class="admin-toolbar">
      <div class="toolbar-center">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Role</mat-label>
          <mat-select [(ngModel)]="roleFilter" (selectionChange)="load()">
            <mat-option value="" disabled hidden>Select role filter</mat-option>
            <mat-option value="Admin">Admin</mat-option>
            <mat-option value="Supervisor">Supervisor</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="statusFilter" (selectionChange)="load()">
            <mat-option value="" disabled hidden>Select status filter</mat-option>
            <mat-option value="active">Active</mat-option>
            <mat-option value="inactive">Inactive</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="toolbar-right">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
          <mat-label>Search users</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput placeholder="Name, email, phone, department" [ngModel]="search" (ngModelChange)="onSearchChange($event)" />
        </mat-form-field>
        <button mat-stroked-button class="toolbar-btn" type="button" (click)="clearFilters()"  style="margin-top: 7px;">
          <mat-icon>filter_alt_off</mat-icon>
          Clear
        </button>
        <button mat-flat-button color="primary" class="toolbar-btn" type="button" (click)="openCreate()"  style="margin-top: 7px;">
          <mat-icon>person_add</mat-icon>
          Add User
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="error" *ngIf="error">{{ error }}</div>

    <div class="loader" *ngIf="loading">
      <mat-spinner diameter="42"></mat-spinner>
      <span>Loading user directory...</span>
    </div>

    <div class="empty-state" *ngIf="!loading && dataSource.filteredData.length === 0">
      <mat-icon>admin_panel_settings</mat-icon>
      <div>No users found</div>
      <p>Create an Admin or Supervisor account to start managing access.</p>
      <button mat-flat-button color="primary" type="button" (click)="openCreate()">
        <mat-icon>person_add</mat-icon>
        Add User
      </button>
    </div>

    <div class="table-wrap" *ngIf="!loading && dataSource.filteredData.length">
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let user">
            <div class="user-cell">
              <strong>{{ displayCell(user.name) }}</strong>
              <span>{{ displayCell(user.email) }}</span>
              <small>{{ displayCell(user.phone) }}</small>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
          <td mat-cell *matCellDef="let user">{{ displayCell(user.role) }}</td>
        </ng-container>

        <ng-container matColumnDef="department">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Department</th>
          <td mat-cell *matCellDef="let user">{{ displayCell(user.department) }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let user">
            <span class="status-badge" [ngClass]="statusClass(user)">
              <mat-icon>{{ statusIcon(user) }}</mat-icon>
              <span>{{ statusLabel(user) }}</span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastLoginAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last login</th>
          <td mat-cell *matCellDef="let user">{{ formatDate(user.lastLoginAt, 'medium') }}</td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
          <td mat-cell *matCellDef="let user">{{ formatDate(user.createdAt, 'mediumDate') }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let user" class="row-actions" style="padding: 18px 0px !important;">
            <button mat-stroked-button class="row-action-btn" type="button" (click)="openEdit(user)">
              <mat-icon>edit</mat-icon>
              Edit
            </button>
            <button mat-stroked-button class="row-action-btn" type="button" (click)="toggleActive(user)">
              <mat-icon>{{ user.active ? 'block' : 'check_circle' }}</mat-icon>
              {{ user.active ? 'Deactivate' : 'Activate' }}
            </button>
            <!-- <button mat-stroked-button class="row-action-btn" type="button" (click)="resetPassword(user)">
              <mat-icon>key</mat-icon>
              Reset
            </button> -->
            <button mat-flat-button color="warn" class="row-action-btn" type="button" (click)="deleteUser(user)">
              <mat-icon>delete</mat-icon>
              Delete
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <mat-paginator *ngIf="!loading && dataSource.filteredData.length" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </mat-card-content>
</mat-card>

<ng-template #userDialog>
  <section class="record-dialog">
    <header class="record-dialog-head">
      <div>
        <span class="eyebrow">{{ formModel._id ? 'Edit access' : 'Create access' }}</span>
        <h2>{{ formModel._id ? 'Edit User' : 'Add Admin / Supervisor' }}</h2>
      </div>
      <button mat-icon-button class="close-button" type="button" (click)="closeDialog()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <form class="record-form" (ngSubmit)="save()">
      <div class="record-dialog-body">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Full Name</mat-label>
          <input matInput placeholder="Full Name" [(ngModel)]="formModel.name" name="name" required minlength="2" maxlength="80" (blur)="normalizeForm()" />
          <mat-error *ngIf="showFieldError('name')">{{ fieldError('name') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Email</mat-label>
          <input matInput type="email" placeholder="Email" [(ngModel)]="formModel.email" name="email" required maxlength="120" [disabled]="!!formModel._id" (blur)="normalizeForm()" />
          <mat-error *ngIf="showFieldError('email')">{{ fieldError('email') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Phone Number</mat-label>
          <input matInput placeholder="Phone Number" [(ngModel)]="formModel.phone" name="phone" inputmode="numeric" maxlength="10" (blur)="normalizeForm()" />
          <mat-error *ngIf="showFieldError('phone')">{{ fieldError('phone') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Department</mat-label>
          <input matInput placeholder="Department" [(ngModel)]="formModel.department" name="department" required minlength="2" maxlength="60" (blur)="normalizeForm()" />
          <mat-error *ngIf="showFieldError('department')">{{ fieldError('department') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Role</mat-label>
          <mat-select [(ngModel)]="formModel.role" name="role" required>
            <mat-option value="" disabled hidden>Select Role</mat-option>
            <mat-option value="Admin">Admin</mat-option>
            <mat-option value="Supervisor">Supervisor</mat-option>
          </mat-select>
          <mat-error *ngIf="showFieldError('role')">{{ fieldError('role') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="!formModel._id">
          <mat-label>Temporary Password</mat-label>
          <input matInput placeholder="Temporary Password" [(ngModel)]="formModel.password" name="password" minlength="8" maxlength="64" />
          <mat-error *ngIf="showFieldError('password')">{{ fieldError('password') }}</mat-error>
        </mat-form-field>

        <div class="error form-error" *ngIf="error">{{ error }}</div>
      </div>

      <footer class="record-dialog-foot">
        <button mat-button type="button" (click)="closeDialog()">Cancel</button>
        <button mat-flat-button color="primary" class="save-btn" type="submit" [disabled]="submitting || !isFormReady()">
          <mat-spinner *ngIf="submitting" diameter="18"></mat-spinner>
          <mat-icon *ngIf="!submitting">save</mat-icon>
          <span>{{ submitting ? 'Saving...' : 'Save User' }}</span>
        </button>
      </footer>
    </form>
  </section>
</ng-template>





